import type { IMosaicTocExpanded } from "./interface";

/**
 * Clears the removed-items list after a successful synchronisation.
 *
 * @param state - The current expanded ToC state.
 * @returns The updated ToC state with no removed items and no pending changes.
 */
export const toc_clearRemoved = (state: IMosaicTocExpanded): IMosaicTocExpanded => ({
  ...state,
  removedItems: [],
  changed: false,
});
